<template>
  <div id="app">
    <div v-if="user !== undefined">
      <header>
        <div id="logoContainer">
          <router-link to="/staff">
            <img id="logo" src="img/cinegest.png" />
          </router-link>
          <span v-if="devmode">DEV MODE</span>
          <br />
          <span class="ml-4" id="name">V. {{$store.state.version}}</span>
          <span class="float-right" id="menuButton">
            <span @click="toggleMenu()">
              <font-awesome-icon id="menubutton" :icon="'bars'" />
            </span>
          </span>
        </div>
      </header>
      <div class="wrapper">
        <sidebar-menu
          @item-click="onItemClick"
          :hideToggle="true"
          :collapsed="!$store.state.menu"
          :menu="menu"
          :width="'300px'"
          style="padding-top: 75px"
        >
          <div class="pt-3 pl-3" slot="header">
            <h3 :style="`color: white; opacity: ${!$store.state.menu?0:1}`">{{user.prenom}}</h3>
          </div>
          <div slot="footer" class="pl-3" :style="`color: white; opacity: ${!$store.state.menu?0:1}`">
            <img id="menulogo" src="img/logo-cinemotion.png" />
            <p id="copyright">&copy; Cinemotion {{moment().year()}}</p>
            <p>
              Développé par
              <br />
              <a href="https://audergonv.ch" target="_blank">Vincent Audergon</a>
            </p>
          </div>
          <span slot="toggle-icon">
            <font-awesome-icon :icon="'eye'" />
          </span>
          <span slot="dropdown-icon">
            <font-awesome-icon :icon="'caret-down'" />
          </span>
        </sidebar-menu>
      </div>
      <div id="content">
        <div class="container well">
          <div v-bind:class="loading ? 'loader' : 'hidden-loader'">
            <h4>
              Chargement...
              <Spinner class="mx-auto" name="wave" color="#4b7be0" />
            </h4>
          </div>
          <div v-bind:class="(loading ? ' loading' : 'not-loading')">
            <transition name="component-fade" mode="out-in">
              <router-view />
            </transition>
          </div>
        </div>
      </div>
      <console v-if="console"></console>
    </div>
    <div v-else>
      <div class="container well" id="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Vue from "vue";
import Console from "./components/Console";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import store from "@/store";
import { isLoggedIn, logout } from "@/auth";
import { SidebarMenu } from "vue-sidebar-menu";
import moment from "moment";

Vue.use(Datetime);

export default {
  name: "app",
  data() {
    return {
      devmode: process.env.VUE_APP_DEV_MODE === 'true',
      moment: moment,
      notifications: [],
      menu: [
        {
          href: "/staff/employes",
          title: "Staff",
          icon: {
            element: "img",
            attributes: { src: "img/group.png" }
          }
        },
        {
          title: "Horaires",
          icon: {
            element: "img",
            attributes: { src: "img/calendar.png" }
          },
          child: [
            {
              href: "/horaires/general",
              title: "Planning général"
            },
            {
              href: "/horaires/employe",
              title: "Planning par employé"
            },
            { href: "/horaires/gestion", title: "Gestion des horaires" },
            {
              href: "/horaires/modification",
              title: "Modification des horaires"
            },
            { href: "/horaires/modeles", title: "Modèles" },
            { href: "/horaires/partic", title: "Particularités" }
          ]
        },
        {
          title: "Heures",
          icon: {
            element: "img",
            attributes: { src: "img/date.png" }
          },
          child: [
            { href: "/heures/gestion", title: "Gestion des heures" },
            {
              href: "/heures/consulter",
              title: "Consulter les heures de travail"
            }
          ]
        },
        {
          title: "Cinestaff",
          icon: {
            element: "img",
            attributes: { src: "img/staff.png" }
          },
          badge: {
            text: this.total,
            class: 'vsm--badge_default'
          },
          child: [
            {
              href: "/cinestaff/remplacements",
              title: "Liste des remplacements",    
              badge: {
                text: this.remplacements,
                class: 'vsm--badge_default'
              },
            },
            { 
              href: "/cinestaff/qsp", 
              title: "QSP",    
              badge: {
                text: this.qsp,
                class: 'vsm--badge_default'
              }, 
            }
          ]
        },
        {
          href: "/vacances",
          title: "Vacances",
          icon: {
            element: "img",
            attributes: { src: "img/fly.png" }
          }
        },
        {
          title: "Options",
          icon: {
            element: "img",
            attributes: { src: "img/settings.png" }
          },
          child: [
            { href: "/settings", title: "Paramètres de l'application" },
            { href: "/aide", title: "Aide" }
          ]
        },
        {
          title: "Déconnexion",
          icon: {
            element: "img",
            attributes: { src: "img/logout.png" }
          },
          attributes: { type: "logout" }
        }
      ],


    };
  },
  watch: {
    stats(){
      this.menu[3].badge.text = this.total;
      this.menu[3].child[0].badge.text = this.remplacements;
      this.menu[3].child[1].badge.text = this.qsp;
    }
  },
  computed: {
    loading() {
      return store.state.loading;
    },
    user() {
      return store.state.user;
    },
    logged() {
      return isLoggedIn();
    },
    enabledNotifications() {
      return this.notifications.filter(notification => {
        if (!notification.inactive) return notification;
      });
    },
    stats(){
      return store.state.stats;
    },
    total(){
      return this.stats.remplacements + this.stats.qsp;
    },
    remplacements(){
      return this.stats.remplacements;
    },
    qsp(){
      return this.stats.qsp;
    },
    console() {
      return store.state.console;
    }
  },
  async created() {
    //  this.notifications = (await api.getNotifications()).notifications;
    this.notifications = [];
    store.commit("setConsole", this.$cookies.get("console") === "true");
    store.dispatch("updateStats");
  },
  mounted(){
  },
  methods: {
    onItemClick(event, item) {
      this.$store.dispatch('updateStats');
      if (item.attributes && item.attributes.type == "logout") this._logout();
    },
    toggleMenu() {
      store.commit("toggleMenu", !store.state.menu);
    },
    _logout() {
      Swal.fire({
        title: "Voulez-vous vous déconnecter?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non"
      }).then(result => {
        if (result.value) {
          logout();
        }
      });
    },
    hideNotification(notification) {
      notification.inactive = true;
    }
  },
  components: { Console, SidebarMenu }
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.05s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>